export default __webpack_public_path__ + "static/media/ic_users.04251e04.svg";